import * as THREE from 'three';
import { ft } from '../core/units.js';
import { OBJECTS } from '../data/objects.js';

/**
 * Draws the animals that are one animal: a body on the ground, the catalogue's
 * colour and size, where the simulation says it is. Reads nothing else.
 */
export function createIndividualView({ individuals }) {
  const group = new THREE.Group();
  group.name = 'individuals';
  const geometry = new THREE.BoxGeometry(1, 1, 1);
  const bodies = new Map();
  for (const row of individuals.rows) {
    const item = OBJECTS[row.kind];
    const body = new THREE.Mesh(geometry, new THREE.MeshStandardMaterial({ color: item?.colour ?? 0x7a6a4a, roughness: 0.95 }));
    body.scale.set(ft(item?.radius ?? 0.4) * 2, ft(item?.height ?? 0.2), ft(item?.radius ?? 0.4) * 5);
    body.castShadow = true;
    group.add(body);
    bodies.set(row.id, body);
  }
  return {
    object3D: group,
    sync() {
      for (const one of individuals.all) {
        const body = bodies.get(one.id);
        body.position.set(one.position.x, body.scale.y / 2, one.position.z);
      }
    },
  };
}
